<template>
  <div class="container">
    <div class="queryFrom">
      <a-row type="flex" style="width: 100%">
        <a-col :sm="24" :md="24" :lg="20" :xl="20">
          <div class="search-keyword">
            <a-input
              placeholder="实验室名称"
              v-model="blurry"
              style="margin: 0 20px"
              allowClear
              @pressEnter="blurrySearch"
              @change="resetHighFields"
            >
            </a-input>
            <a-select placeholder="启用状态" v-model="enableSearchValue"  style="width: 330px; margin-right:20px" @change="enableChange" allowClear>
              <a-select-option :value="2">
                已启用
              </a-select-option>
              <a-select-option :value="3" >
                未启用
              </a-select-option>
            </a-select>
            <a-button type="primary" icon="search" @click="blurrySearch">搜索</a-button>
          </div>
        </a-col>
      </a-row>
    </div>
    <div class="table">
      <a-table
        :columns="columns"
        :dataSource="tableData"
        :pagination="pagination"
        @change="pagChange"
        :rowKey="(record) => record.id"
        :loading="loading"
        style="background: #fff"
      >
        <template slot="laboratoryName"></template>
        <template slot="userName"></template>
        <template slot="userPhones"></template>
        <template slot="canOrder" slot-scope="record">
          <a-switch
            v-model="record.canOrder"
            @change="canOrderChange(record.id)"
          />
        </template>
        <template slot="indexShow" slot-scope="record">
          <span>{{ record ? "是" : "否" }}</span>
        </template>
        <template slot="sort" slot-scope="record">
          <a-input-number 
              :min="0"
              :value="Number(record.sort)"
              @change="(value)=>{sortChange(value,record)}"
              @mouseleave="mouseOut"
              style="text-align:center; width: 60px;"
          />
        </template>
        <template slot="operation" slot-scope="record">
          <a-button @click="editShow(record)" type="link" style="padding: 0"
            >编辑</a-button
          >&nbsp;
          <a-button @click="showDetails(record)" type="link" style="padding: 0"
            >详情</a-button
          >
        </template>
      </a-table>
    </div>
    <div>
      <!-- 编辑页 -->
      <labEditForm v-if="editVisible" :id="id" @hiddenAction="closeEdit"></labEditForm>
      <!-- 详情页 -->
      <a-modal
        title="详情"
        :visible="detailsVisible"
        centered
        @cancel="closeDetails"
        :footer="null"
      >
        <a-row class="detailsText">
          <a-col :span="6" class="right">实验室名称：</a-col>
          <a-col :span="18"
            ><p>{{ detailsObj.name }}</p></a-col
          >
        </a-row>
        <a-row class="detailsText">
          <a-col :span="6" class="right">实验室简介：</a-col>
          <a-col :span="18"
            ><p>{{ detailsObj.introduction }}</p></a-col
          >
        </a-row>
        <a-row class="detailsText">
          <a-col :span="6" class="right">实验室LOGO：</a-col>
          <a-col :span="18" v-if="detailsObj.logo">
            <img :src="detailsObj.logo" alt="实验室LOGO" class="logo"/>
          </a-col>
        </a-row>
      </a-modal>
    </div>
  </div>
</template>

<script>
import {
  getAllLaboratorys,
  getLaboratorydDetails,
  modifyLaboratoryCanOrder,
  laboratorySort,
} from "@/api/laboratory";
import labEditForm from '@/components/users/labEditForm.vue'
import { formatDate } from "../../utils/date";
import { getToken } from "@/utils/auth";
const align = "center";
const columns = [
  {
    dataIndex: "No",
    title: "序号",
    align,
    // customRender: (text, record, index) => `${index + 1}`, // 显示每一行的序号
  },
  {
    title: "实验室名称",
    dataIndex: "name",
    scopedSlots: { customRender: "laboratoryName" },
    align,
  },
  {
    title: "联系人",
    dataIndex: "userName",
    scopedSlots: { customRender: "userName" },
    align,
  },
  {
    title: "联系方式",
    dataIndex: "phone",
    scopedSlots: { customRender: "userPhones" },
    align,
  },
  {
    title: "启用状态",
    // dataIndex: "canOrder",
    scopedSlots: { customRender: "canOrder" },
    align,
  },
  {
    title: "首页展示",
    dataIndex: "indexShow",
    scopedSlots: { customRender: "indexShow" },
    align,
  },
  {
    title: "排序",
    // dataIndex: "sort",
    scopedSlots: { customRender: "sort" },
    align,
  },
  {
    title: "操作",
    scopedSlots: { customRender: "operation" },
    align,
  },
];

export default {
  components:{ labEditForm },
  data() {
    return {
      id: 0,
      isClick:false,
      columns,
      tableData: [],
      loading: false,
      editVisible: false,
      detailsVisible: false,
      blurry: "",
      pagination: {
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "30", "40", "50"],
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: (total) => `共 ${total} 条记录`,
        showSizeChange: (current, pageSize) => {
          this.pageSize = pageSize;
        },
      },
      isFilter: false,
      detailsObj: {},
      canOrder: true,
      indexShow: false,
      sort: 0,
      enableSearchValue: undefined,
    };
  },
  created() {
  },
  mounted() {
    this.getAllLaboratorys();
  },
  methods: {
    // 按启用状态检索
    enableChange(value) {
      this.pagination.current = 1
      this.enableSearchValue = value;
      this.getAllLaboratorys();
    },
    mouseOut(){
      if(this.isClick){
        this.getAllLaboratorys();
        this.isClick=false;
      }
    },
    // 更改实验室启用状态
    canOrderChange(id) {
      this.modifyLaboratoryCanOrder(id);
    },
    // 列表页修改排序
    sortChange(value,row){
      row.sort = value;
      this.isClick = true;
      let params = {
        id: row.id,
        sort: value
      }
      laboratorySort(params)
        .then(res => {

        })
        .catch(error => {
          console.log(error);
        })
    },
    // 获取实验室企业列表
    getAllLaboratorys() {
      let params = {
        page: this.pagination.current - 1,
        size: this.pagination.pageSize,
        blurry: this.blurry,
      };
      if(this.enableSearchValue!=undefined) {
        params.canOrder = this.enableSearchValue==2?true:false;
      }
      this.loading = true;
      getAllLaboratorys(params)
        .then((res) => {
          this.tableData = res.content;
          for(let i=0; i<this.tableData.length; i++) {
            this.tableData[i].No = (this.pagination.current - 1) * this.pagination.pageSize + i + 1
          }
          this.pagination.total = res.totalElements;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          console.log(error);
        });
    },
    handlePreviewUrl(url) {
      if (url && url[0] === '/') {
        return window.location.origin + url;
      } else {
        return url;
      }
    },
    // 获取实验室详情
    getLaboratorydDetails(id) {
      getLaboratorydDetails(id)
        .then((res) => {
          this.id = res.id;
          this.detailsObj = res;
          this.detailsObj.logo = res.logo ? this.handlePreviewUrl(res.logo.inlineUrl) : '';
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 修改实验室启用状态
    modifyLaboratoryCanOrder(id) {
      modifyLaboratoryCanOrder(id)
        .then((res) => {
          console.log("修改成功：", res);
        })
        .catch((error) => {
          console.log(error);
        });
    },

    // 显示详情
    showDetails(row) {
      this.detailsVisible = true;
      this.getLaboratorydDetails(row.id);
    },
    // 关闭详情
    closeDetails() {
      this.detailsVisible = false;
      this.detailsObj={}
    },
    // 显示编辑
    editShow(row) {
      this.editVisible = true;
      this.id = row.id;
      this.getLaboratorydDetails(row.id);
    },
    // 关闭编辑页面
    closeEdit() {
      this.editVisible = false;
      this.detailsObj={};
      this.getAllLaboratorys();
    },

    /*** 翻页 */
    pagChange(pagination, filters, sorter) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.getAllLaboratorys();
    },
    // 模糊搜索
    blurrySearch() {
      this.loading = true;
      this.pagination.current = 1;
      this.getAllLaboratorys();
      this.isFilter = true;
    },
    // 重置搜索
    resetHighFields(e) {
      if(e.target.value==='') {
        this.loading = true;
        this.blurry = "";
        this.pagination.current = 1;
        this.getAllLaboratorys();
        this.isFilter = false;
      }
    },
  },
  filters: {
    formatDateTime(time) {
      if (time) {
        let date = new Date(time);
        return formatDate(date, "yyyy-MM-dd hh:mm:ss");
      } else {
        return "";
      }
    },
  },
};
</script>
<style lang="less" scoped>
.green {
  color: #67c23a;
}
.red {
  color: #f56c6c;
}
.ant-form-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}
.container {
  min-height: 100%;
  // background-color: #fff;
  // padding: 15px;
  .queryFrom {
    margin-bottom: 15px;
    background-color: #fff;
    overflow: hidden;
    padding: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .search-keyword {
      max-width: 600px;
      width: 57%;
      min-width: 400px;
      float: left;
      margin: 8px 20px 8px 0;
      display: flex;
      align-items: center;
      .ant-input {
        margin-right: 10px;
      }
    }
    .advanced-search {
      margin: 8px 20px 8px 0;
      .form-container {
        width: 600px;
      }
    }
  }
  .btnTag {
    height: 32px;
    line-height: 32px;
    font-size: 14px;
    border-radius: 4px;
    margin-right: 5px;
    p {
      line-height: 32px;
    }
  }
}
//
.font-color-red {
  color: red;
}
.ant-form-item[data-v-cb0a15d2] {
  justify-content: left;
}
.detailsText {
  vertical-align: middle;
  margin-top: 10px;
  font-size: 16px;
  color: #333;
}
.detailsText .right {
  text-align: right;
}
.logo {
  width: 50px;
  height: 50px;
}
// 上传图片
.upload-box {
  width: 100px;
  height: 100px;
  display: inline-block;
}
.img-list {
  width: 150px;
  height: 100px;
  text-align: center;
  position: relative;
  margin-left: 30px;
  display: inline-block;
  .img {
    width: 100%;
    height: 100%;
    img {
      width: 80px;
      height: 80px;
    }
  }
}


</style>
